import { render, staticRenderFns } from "./add-mailbox.vue?vue&type=template&id=4f1d0862&scoped=true&"
import script from "./add-mailbox.vue?vue&type=script&lang=js&"
export * from "./add-mailbox.vue?vue&type=script&lang=js&"
import style0 from "./add-mailbox.vue?vue&type=style&index=0&id=4f1d0862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d0862",
  null
  
)

export default component.exports